export default Object.freeze({
    Standart: 'Standart',
    Collapsible: 'Collapsible',
});
